<template style='text-align:left'>

    <v-layout row >
      <v-flex xs12 mx-0>
        <div style='width:14em;float:left'> {{$dayTypes.find(x => x.value === sp.type).text}}</div>
        <div style='width:8em;float:left;text-align:right'>{{sp.days}} days</div>
      </v-flex>
    </v-layout> 
</template>        

<script>
export default {

  components: { },
  props: {
    sp: null
  }
}
</script>

<style>
.lite {color:#aaaaaa} ;
</style>



// WEBPACK FOOTER //
// src/components/Person/ShowServiceDays.vue